import React, { Component } from 'react';
import { Table, Form } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  toPage = record => {
    this.props.router.push({
      pathname: `/finance/budget/${record.uuid}/set_manage/detail`,
    });
  };

  columns = () => {
    const {
      dataSource: { pagination },
    } = this.props;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    return [
      {
        title: '编号',
        dataIndex: 'num',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '流水编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => <Link onClick={() => this.toPage(record)}>{text}</Link>,
      },
      {
        title: '预算组名称',
        dataIndex: 'groupName',
        key: 'groupName',
      },
      {
        title: '预算年度',
        dataIndex: 'year',
        key: 'year',
      },
      {
        title: '预算总额',
        dataIndex: 'budget',
        key: 'budget',
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        render: (text, record) => {
          return <span>{text || '-'}</span>;
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : '暂无数据'}</span>;
        },
      },
      {
        title: '当前环节-处理人',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return <span>{currentActivity.uuid ? `${name || ''}-${processorName || ''}` : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          const element = record.instance ? <span>审核中</span> : <span>待编辑</span>;
          return instance.status === 1 ? <span style={{ color: 'red' }}>已完成</span> : element;
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        loading={loading}
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/finance/budget/set/TableSet.js